// EXTERNAL DEPENDENCIES
import React, { useEffect, useState } from 'react'

// COMPONENTS
import { Avatar, MerchantIcon } from '@paypalcorp/pp-react'
import { ProfilePhotoOverlay } from '../photo-overlays/profile-photo-overlay'

// HELPERS
import { parseAndTrackClick } from '@/utils'

// TEST IDS
import {
  PROFILE_PHOTO_AVATAR_TEST_ID,
  PROFILE_PHOTO_IMAGE_TEST_ID,
} from '@/constants/test-ids'

// STYLES
import { mainBrandPrimaryBlueText } from '@/styles/colors'
import styles from './styles.module.less'

/**
 * Displays the profile photo src as rounded Avatar
 */
export default function ProfilePhotoDisplay({
  handleClick,
  children,
  shouldShowOverlay,
  isLoading,
  src,
  fpti,
}: Readonly<{
  children?: React.ReactElement
  handleClick?: () => void
  shouldShowOverlay?: boolean
  isLoading?: boolean
  src: string
  fpti?: string
}>) {
  const [updatedSrc, setUpdatedSrc] = useState(src)

  useEffect(() => {
    setUpdatedSrc(src)
  }, [src])

  const handleClickWithFpti = () => {
    parseAndTrackClick(fpti)
    handleClick()
  }

  return (
    <div className={styles.overlayContainer}>
      <Avatar
        aria-hidden
        className={styles.roundPhotoImage}
        isLoading={isLoading}
        src={updatedSrc}
        data-testid={PROFILE_PHOTO_IMAGE_TEST_ID}
        data-fpti={fpti}
        alt=''
        tabIndex={-1}
        svgIconComponent={() => (
          <MerchantIcon
            aria-hidden
            color={mainBrandPrimaryBlueText}
            size='xl'
            data-testid={PROFILE_PHOTO_AVATAR_TEST_ID}
            data-fpti={fpti}
          />
        )}
      />
      {!isLoading && shouldShowOverlay ? (
        <ProfilePhotoOverlay
          handleClick={handleClick ? handleClickWithFpti : null}
        />
      ) : null}
      {children}
    </div>
  )
}
